import { nanoid } from 'nanoid';

export function openDB(dbName, version = 1) {
	return new Promise((resolve, reject) => {
		//  兼容浏览器
		var indexedDB =
			window.indexedDB ||
			window.mozIndexedDB ||
			window.webkitIndexedDB ||
			window.msIndexedDB;
		let db;
		// 打开数据库，若没有则会创建
		const request = indexedDB.open(dbName, version);
		// 数据库打开成功回调
		request.onsuccess = function (event) {
			db = event.target.result; // 数据库对象
			// console.log("数据库打开成功");
			resolve(db);
		};
		// 数据库打开失败的回调
		request.onerror = function (event) {
			console.log("数据库打开报错");
		};
		// 数据库有更新时候的回调
		request.onupgradeneeded = function (event) {
			// 数据库创建或升级的时候会触发
			console.log("onupgradeneeded");
			db = event.target.result; // 数据库对象
			var objectStore;
			// 创建存储库
			objectStore = db.createObjectStore("Cords", {
				keyPath: "loc", // 这是主键
				// autoIncrement: true // 实现自增
			});
		};
	});
}

// var db;
// openDB("panelDB").then(res => { db = res });

export function addData(db, storeName, data) {
	var request = db
		.transaction([storeName], "readwrite") // 事务对象 指定表格名称和操作模式（"只读"或"读写"）
		.objectStore(storeName) // 仓库对象
		.add(data);

	// request.onsuccess = function (event) {
	// 	console.log("数据写入成功");
	// };

	request.onerror = function (event) {
		console.log("数据写入失败");
	};
}

// addData(db, "Cords", {loc:'北京',lat:40, lon:116.2})

export function getDataByKey(db, storeName, key) {
	return new Promise((resolve, reject) => {
		var transaction = db.transaction([storeName]); // 事务
		var objectStore = transaction.objectStore(storeName); // 仓库对象
		var request = objectStore.get(key); // 通过主键获取数据

		request.onerror = function (event) {
			console.log("事务失败");
		};

		request.onsuccess = function (event) {
			// console.log("主键查询结果: ", request.result);
			resolve(request.result);
		};
	});
}

// getDataByKey(db, "Cords", "北京").then(res => { console.log(res) })

// 获取全量数据，并以数组形式返回
export function cursorGetDataToList(db, storeName, callBack) {
	let list = [];
	var store = db
		.transaction(storeName, "readwrite") // 事务
		.objectStore(storeName); // 仓库对象
	var request = store.openCursor(); // 指针对象
	// 游标开启成功，逐行读数据
	request.onsuccess = function (e) {
		var cursor = e.target.result;
		if (cursor) {
			// 必须要检查
			list.push({ ...cursor.value, id: nanoid() });
			cursor.continue(); // 遍历了存储对象中的所有内容
		} else {
			// console.log("游标读取的数据：", list);
			callBack(list)
		}
	};
}

export function updateDB(db, storeName, data) {
	db.transaction([storeName], "readwrite").objectStore(storeName).put(data);
}

export function deleteDB(db, storeName, id) {
	db.transaction([storeName], "readwrite").objectStore(storeName).delete(id);
}
